<template>
  <div>
    <div class="clearfix row py-2 mb-2 no-margin">
      <div class="col-sm-6 pl-0">
        <div class="custom-search">
          <b-input-group class="mb-0">
            <b-input-group-prepend is-text>
              <b-icon icon="search"></b-icon>
            </b-input-group-prepend>
            <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
          </b-input-group>
        </div>
      </div>



      <div class=" col-sm-6 text-right pr-0">
        <b-button id="show-btn" class="" v-if="ce" @click="addNew()">Add New Leave</b-button>
        <b-button  class="custom-wizard-btn ml-1" v-b-toggle.sidebar_right_1><b-icon class="mr-2" icon="funnel-fill" ></b-icon> Filter</b-button>
      </div>
    </div>

    <div class="row justify-content-center no-margin">
      <div class="col-sm-12  px-0">
        <b-overlay :show="showoverlay_list" rounded="sm">
          <table class="table dataTable">
            <thead class="">
            <tr class="table-head">
              <td class="cusror-pointer" v-for="column in columns" :key="column.name" @click="sortBy(column.name)" :class="sortKey == column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"><span>{{column.label}}</span></td>
              <td class="text-right" v-if="ce">Action</td>
            </tr>
            </thead>
            <tbody>
            <template v-for="(leave , n) in paginatedData">
              <tr class="table-row hover-bg" :key="n" :class="{ 'text-danger': excess[leave.employee_id + '|' + leave.leave_type_id]}">
                <td class=" ">
                  <div class="img-holder">
                    <img v-bind:src="'/avatar/'+ leave.company_id + '/' + leave.employee_pic" class="img-fluid img-thumbnail employee-avatar mr-2" />
                  </div>
                  <div class="name-holder">
                    {{leave.employee_name}}<br />
                    <span class="txt-alt">{{leave.employee_code}}</span>
                  </div>
                </td>
                <td class="">
                  {{leave.jobposition}}
                </td>
                <td class="">
                  {{leave.department}}
                </td>
                <td class="">
                  <b-icon :icon="leave.icon || 'calendar'" class="mr-2 text-primary" font-scale="1.1"></b-icon>
                  {{leave.leave_type}}
                </td>
                <td class="">
                  {{leave.from}}
                </td>
                <td class="">
                  {{ leave.to }}
                </td>
                <td class="">
                  <template v-if="leave.leave_day == 0">
                    {{ leave.number_of_days }}
                    <template v-if="leave.is_roster == 0">
                      <span v-if="leave.number_of_days > 1">days</span>
                      <span v-else>day</span>
                    </template>
                    <template v-else>
                      <span v-if="leave.number_of_days > 1">shifts</span>
                      <span v-else>shift</span>
                    </template>
                  </template>
                  <template v-else-if="leave.leave_day == 1">First Half</template>
                  <template v-else-if="leave.leave_day == 2">Second Half</template>
                </td>

                <td v-if="roster == 1">
                  <template v-if="leave.shifts && Object.keys(leave.shifts).length > 0">
                    <div v-for="(shifts_arr, date) in leave.shifts" :key="date" class="d-inline">
                      <small
                          v-for="shift in shifts_arr"
                          :key="shift.id || shift.code || shift.name"
                          v-b-tooltip.hover
                          :title="`Date: ${date} - Shift: ${shift.name} : ${moment(shift.start_time, 'hh:mm A').format('hh:mm A')} - ${moment(shift.end_time, 'hh:mm A').format('hh:mm A')}`"
                          class="border rounded p-1 mr-1"
                          :style="`background-color:${(shift.color || '#000') + '22'}; color:${shift.color || '#000'};`"
                      >
                        {{ shift.code }}
                      </small>
                    </div>
                  </template>
                  <span v-else>N/A</span>
                </td>

                <td class="leave-reason-wrapper">
                  {{leave.reason}} <br />
                  <b-link v-if="leave.attachment != ''" @click="downloadFileContent('/avatar/'+ leave.company_id + '/leaves/' + leave.attachment)">
                    <b-icon icon="download"  class="ml-1" v-b-tooltip.hover title="Attachment"></b-icon>
                  </b-link>
                </td>

                <td class="">
                  <span class="leave-status" v-if="leave.status == 'Approved'"><i class="far fa-dot-circle mr-1 text-success"></i>{{leave.status}}</span>
                  <span class="leave-status" v-else-if="leave.status == 'Applied'"><i class="far fa-dot-circle mr-1 text-primary"></i>Applied</span>
                  <span class="leave-status" v-else-if="leave.status == 'Declined'"><i class="far fa-dot-circle mr-1 text-danger"></i>{{leave.status}}</span>
                </td>

                <td class="">
                  {{leave.updated_by}}
                </td>

                <td class="position-relative text-right" v-if="ce">
                  <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                  <div class="dropdown-menu action-dropdown-menu px-0 py-1 w-200" aria-labelledby="actionDropdown">
                    <b-button-group class="mr-0">

                      <b-button class="mr-3 rounded edit-btn" title="Approve Leave" v-if="leave.flg_status == 0" @click="showReplacementModal(leave)">
                        <b-icon icon="check" class="mr-2" aria-hidden="true" ></b-icon>Approve
                      </b-button>

                      <b-button class="mr-3 rounded edit-btn" title="Decline Leave" v-if="leave.flg_status == 0" @click="updateLeave(leave.employee_id,leave.leave_type_id,leave.flg_status,leave.from,leave.to , 2)">
                        <b-icon icon="x" class="mr-2" aria-hidden="true" ></b-icon>Reject
                      </b-button>

                      <b-button class="mr-3 rounded edit-btn" title="Delete Leave" @click="deleteLeave(leave.employee_id,leave.leave_type_id,leave.flg_status,leave.from,leave.to)">
                        <b-icon icon="trash" class="mr-2" aria-hidden="true" ></b-icon>Delete
                      </b-button>

                      
                      <b-button class="mr-3 rounded edit-btn" title="Check Limits" @click="checkLimits(leave.employee_id)">
                        <b-icon icon="check-circle" class="mr-2" aria-hidden="true" ></b-icon>Check Limits
                      </b-button>    
                    </b-button-group>
                  </div>

                </td>
              </tr>
            </template>
            </tbody>
          </table>


          <div v-if="paginatedData.length == 0" class="list-no-data">
            No records found.
          </div>
          <div v-else class="px-3 mt-4">
            <ul class="pagination b-pagination float-left mb-0 mt-1">
              <li class="page-item disabled m-2">View</li>
              <li class="page-item disabled">
                <b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select>
              </li>
              <li class="page-item disabled m-2">per page. Total {{leaves.length}} records found.</li>
            </ul>
            <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ><template #prev-text><span>Previous</span></template><template #next-text><span>Next</span></template></b-pagination-nav>
          </div>
        </b-overlay>
      </div>
    </div>


    <b-sidebar id="sidebar_right_1" title="Filter" right shadow>
      <template v-slot:default="{ hide }">
        <div class="px-3 py-2">
          <b-input-group class="mb-2">
            <b-input-group-prepend is-text>
              <b-icon icon="list"></b-icon>
            </b-input-group-prepend>
            <select name="department_id" class='form-control' v-model='search_by_id.department_id'>
              <option value='0' >Select Department</option>
              <option v-for='data in depertments' :value='data.id'>{{ data.name }}</option>
            </select>
          </b-input-group>

          <b-input-group class="mb-2">
            <b-input-group-prepend is-text>
              <b-icon icon="list"></b-icon>
            </b-input-group-prepend>
            <select name="department_id" class='form-control' v-model='search_by_id.leave_type_id'>
              <option value='0' >Select Leave Category</option>
              <option v-for='data in leavetypes' :value='data.id'>{{ data.title }}</option>
            </select>
          </b-input-group>



          <b-form-group id="day_one-group" label="From [YYYY-MM-DD]" label-for="day_one_text" class="mt-4">
            <b-input-group class="mb-3">
              <b-form-input id="day_one_text" name="day_one_text" v-model="day_one" v-validate="{ required: true }" type="text" placeholder="YYYY-MM-DD" autocomplete="off" @change="updateToDate" ></b-form-input>
              <b-input-group-append>
                <b-form-datepicker id="day_one" @context="updateToDate()" button-only right locale="en-US" v-model="day_one" :date-disabled-fn="dateDisabled" :start-weekday="fetchStartWeekday"></b-form-datepicker>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>


          <b-form-group id="day_two-group" label="To [YYYY-MM-DD]" label-for="day_two_text">
            <b-input-group class="mb-3">
              <b-form-input id="day_two_text" name="day_two_text" v-model="day_two" v-validate="{ required: true }" type="text" placeholder="YYYY-MM-DD" autocomplete="off" @change="checkValidDate" ></b-form-input>

              <b-input-group-append>
                <b-form-datepicker id="day_two" button-only right locale="en-US" :min="min"  v-model="day_two" :date-disabled-fn="dateDisabled" :start-weekday="fetchStartWeekday"></b-form-datepicker>
              </b-input-group-append>


            </b-input-group>
          </b-form-group>


          <div class="mt-4 row" >
            <div class="col-6">
              <b-button class="" variant="primary" block  title="Set Filter"  @click="setFlter();">Set Filter</b-button>
            </div>
            <div class="col-6">
              <b-button class="" variant="primary" block  title="Clear Filter" @click="resetFlter();">Clear Filter</b-button>
            </div>
          </div>
        </div>
      </template>
    </b-sidebar>


    <b-modal id="employeeLeavesLimitCheck" hide-footer title="Allowed Leaves" dialog-class="w-1000">
      <div class="row mt-4">

        <div class="col-sm-12 table-responsive">
          <table class="table">
            <thead>
            <tr class="table-head">
              <th>Type</th>
              <th>Leaves Allowed</th>
              <th v-if="carry == 1">Carried</th>
              <th>Available</th>
              <th>Applied</th>
              <th>Enjoyed</th>
              <th>Deducted</th>
              <th v-if="encash == 1">Encashed</th>
              <th>Remaining</th>
            </tr>
            </thead>
            <tbody>
            <tr class="table-row hover-bg" v-for="leave_type in leave_available" :key="leave_type.id">
              <td>
                <b-icon :icon="leave_type.icon || 'calendar'" class="mr-2 text-primary" font-scale="1.1"></b-icon>
                {{leave_type.leave_title}}
              </td>

              <td>{{leave_type.allowed}} {{ getBasisText(leave_type.basis) }}</td>

              <td v-if="carry == 1">{{leave_type.carried}} {{ getBasisText(leave_type.basis) }}</td>
              <td>{{leave_type.leave_days}} {{ getBasisText(leave_type.basis) }}</td>
              <td>{{leave_type.applied}} {{ getBasisText(leave_type.basis) }}</td>
              <td>{{leave_type.enjoyed}} {{ getBasisText(leave_type.basis) }}</td>
              <td>{{leave_type.deducted}} {{ getBasisText(leave_type.basis) }}</td>
              <td v-if="encash == 1">{{leave_type.encashed}} {{ getBasisText(leave_type.basis) }}</td>
              <td>{{leave_type.remaining}} {{ getBasisText(leave_type.basis) }}</td>
            </tr>
            </tbody>
          </table>

        </div>

      </div>
    </b-modal>

    <b-modal id="bv-modal-add-leave" size="xl" scrollable  hide-footer title="Leave Details" @hidden="employee_id = 0">
      <roster-search-employees v-if="employee_id == 0"  :flg="1" :all="1" v-on:childToParent="setEmployee"></roster-search-employees>
      <roster-employee-leave-details v-if="employee_id > 0"  :editflg="0" v-on:childToParent="getLeavesNew" @hideModal="hideModal"></roster-employee-leave-details>
    </b-modal>


    <b-modal id="bv-modal-edit-leave" size="xl" scrollable  hide-footer title="Leave Details">
      <roster-employee-leave-details v-if="employee_id > 0"  :editflg="1" :leave_type_id="tmp_leave_type_id" :flg_status="tmp_flg_status" :from="tmp_from" :to="tmp_to" :leave_day="tmp_leave_day" v-on:childToParent="getLeavesNew"></roster-employee-leave-details>
    </b-modal>


    <b-modal id="bv-modal-import-leave" scrollable  hide-footer title="Import Leaves">
      <b-overlay :show="showoverlay" rounded="sm" class="">
        <b-form-file id="datafile" @change="checkFileType($event , 'datafile', ['.xls', '.xlsx'])" name="datafile" accept=".xlsx,.xls"></b-form-file>


        <div v-if='errormsg'>
          <div v-if="errormsg.length > 0" class="alert alert-danger my-3">Total error {{errormsg.length}}</div>
          <ul class="list-group ">
            <li class="list-group-item list-group-item-danger" v-for='error in errormsg'>{{error}}</li>
          </ul>
        </div>
      </b-overlay>
    </b-modal>

    <b-modal id="approve-leave-modal" size="lg" centered hide-footer title="Approve Leave Request" modal-class="alm-modal">
      <div class="ibox px-3 py-4 alm-section mb-3 p-0">

        <div class="alm-section-title px-3 pt-3 pb-2">
          <b-icon icon="person-lines-fill" class="mr-2"></b-icon>
          Leave Request Details
        </div>
        <div class="px-3 pb-3">
          <div class="alm-details">
            <div class="row no-gutters">
              <div class="col-md-6 py-2 px-3">
                <div class="alm-kv">
                  <div class="alm-k">Employee</div>
                  <div class="alm-v">{{ employeeLeaveDetails.employee }}</div>
                </div>
                <div class="alm-kv">
                  <div class="alm-k">Leave Category</div>
                  <div class="alm-v">{{ employeeLeaveDetails.leaveType }}</div>
                </div>
                <div class="alm-kv">
                  <div class="alm-k">Period</div>
                  <div class="alm-v">{{ employeeLeaveDetails.period }}</div>
                </div>
              </div>
              <div class="col-md-6 py-2 px-3">
                <div class="alm-kv">
                  <div class="alm-k">Department</div>
                  <div class="alm-v">{{ employeeLeaveDetails.department }}</div>
                </div>
                <div class="alm-kv">
                  <div class="alm-k">Duration</div>
                  <div class="alm-v">{{ employeeLeaveDetails.duration }}</div>
                </div>
                <div class="alm-kv">
                  <div class="alm-k">Reason</div>
                  <div class="alm-v text-muted">{{ employeeLeaveDetails.reason }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ibox px-3 py-4 alm-section p-0">
        <div class="alm-section-title px-3 pt-3 pb-2">
          <b-icon icon="people" class="mr-2"></b-icon>Replacement Assignment
        </div>

        <div class="px-3 pb-3">
          <div class="mb-2 font-weight-500">Replacement Assignment Mode</div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <div class="alm-mode-card border rounded" :class="{ active: mode==0 }" role="button" @click="mode=0">
                <div class="d-flex align-items-start">
                  <div class="alm-dot mr-2" :class="{ on: mode==0 }"></div>
                  <div>
                    <div class="font-weight-600 mb-1">Keep empty</div>
                    <div class="text-muted small">
                      No replacement employees for each date
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <div class="alm-mode-card border rounded" :class="{ active: mode==1}" role="button" @click="mode=1;">
                <div class="d-flex align-items-start">
                  <div class="alm-dot mr-2" :class="{ on: mode==1 }"></div>
                  <div>
                    <div class="font-weight-600 mb-1">Manual Assignment</div>
                    <div class="text-muted small">
                      Manually select replacement employees from available staff for each shift
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <b-list-group v-if="mode==1">
            <div v-for="(shifts_arr, date) in employeeLeaveDetails.shifts" :key="date" class="w-100">
              <b-list-group-item v-for="shift in shifts_arr" :key="`${date}-${shift.id}`" class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <div class="rounded-circle mr-3" :style="{ width: '16px', height: '16px', backgroundColor: shift.color }"></div>

                  <div>
                    <div class="font-weight-bold">{{ shift.name }} ({{ shift.code }}) → Period Date:<span class="font-weight-normal">{{ date }}</span>
                    </div>

                    <small class="text-muted">{{ moment(shift.start_time, 'hh:mm A').format('hh:mm A') }} → {{ moment(shift.end_time, 'hh:mm A').format('hh:mm A') }}
                    </small>
                  </div>
                </div>

                <div class="w-25">
                  <div v-if="unassigned_employees[date][String(shift.id)]" class="d-flex flex-row justify-content-end align-items-center">
                    <b-form-select :disabled="isPastDate(date)" :value="selected_unassigned_employees[date][String(shift.id)]"
                        @input="val => setSelected(date, shift.id, val)" :options="unassigned_employees[date][String(shift.id)]" size="sm" class="w-100"></b-form-select>

                    <b-button class="px-1 py-0 ml-1" variant="danger" @click="setSelected(date, shift.id, null)">
                      <b-icon icon="x-circle"></b-icon>
                    </b-button>
                  </div>

                  <b-form-select v-else disabled size="sm" class="w-100" placeholder="No unassigned employees"></b-form-select>
                </div>
              </b-list-group-item>
            </div>
          </b-list-group>

          <div v-if="mode == 1 && (!employeeLeaveDetails.shifts || Object.keys(employeeLeaveDetails.shifts).length === 0)" class="alm-empty text-center p-4 my-2">
            <b-icon icon="calendar-x" class="text-muted mb-2" font-scale="2.5"></b-icon>
            <div class="font-weight-600 text-dark mb-1">No Shifts Found</div>
            <div class="text-muted small">
              There are no scheduled shifts during this leave period. Replacement assignments are only required for scheduled shifts.
            </div>
          </div>




        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center mt-3">
        <b-button variant="secondary" class="px-4" @click="$bvModal.hide('approve-leave-modal')">Cancel</b-button>
        <b-button variant="primary" class="px-4" @click="updateLeave(employeeLeaveDetails.leave.employee_id,employeeLeaveDetails.leave.leave_type_id,employeeLeaveDetails.leave.flg_status,employeeLeaveDetails.leave.from,employeeLeaveDetails.leave.to , 1)" v-if="mode == 0">
          <b-icon icon="check2-circle" class="mr-1"></b-icon>Approve
        </b-button>
        <b-button variant="primary" class="px-4" @click="replaceShifts" v-else>
          <b-icon icon="check2-circle" class="mr-1"></b-icon>Approve with Replacements
        </b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import moment from 'moment'
export default{

  mounted() {
    if(this.check_ce == 1)
    {
      if(this.ce_flg == 1)
        this.ce = true;
      else
        this.ce = false;

    }
  },
  props: [ 'flg', 'roster'],
  components: {},
  data(){
    /** Sohel Code Starts Here */
    let sortOrders = {};
    let columns = [
      {label: 'Employee', name: 'employee_name' },
      {label: 'Job Position', name: 'employee_code' },
      {label: 'Department', name: 'department' },
      {label: 'Leave Category', name: 'leave_type'},
      {label: 'From', name: 'from'},
      {label: 'To', name: 'to'},
      {label: 'No. of Days/Shifts', name: 'number_of_days'},
      {label: 'Shift(s)', name: 'shifts'},
      {label: 'Reason', name: 'reason'},
      {label: 'Status', name: 'status'},
      {label: 'Updated By', name: 'updated_by'},
    ];
    columns.forEach((column) => {sortOrders[column.name] = -1;});
    /** Sohel Code Ends Here */

    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    const minDate = new Date(today);
    minDate.setMonth(minDate.getMonth());
    minDate.setDate(minDate.getDate());
    const startdate = minDate;
    var startDate = '';
    var endDate = '';
    //var today = new Date();
    if ((today.getMonth() + 1) <= 6)
    {
      startDate = (today.getFullYear() - 1) + '-07-1';
      endDate = (today.getFullYear()) + '-06-30';
    }
    else
    {
      startDate = (today.getFullYear()) + '-07-1';
      endDate = (today.getFullYear() + 1) + '-06-30';
    }

    return {
      carry: 0,
      encash: 0,
      mode: 0,
      excess:[],
      leave_available: [],
      employeeLeaveDetails:{
        leave: null,
        employee: '',
        department: '',
        leaveType: '',
        duration: '',
        period: '',
        reason: '',
        shifts:[],
      },
      manualDisabled: false,
      depertments:[],
      search_by_id:{department_id:0, leave_type_id:0 , flg_status:0},
      startDate : startDate,
      endDate : endDate,
      min: minDate,
      day_one: moment(String(startdate)).format('YYYY-MM-DD') ,
      day_two: moment(String(startdate)).format('YYYY-MM-DD') ,
      all_week_holidays : [],
      week_start_day : 7,
      holidays_date_arr : [],
      leavetypes: [],
      flg_status : [
        { text: 'Applied', value: '0' },
        { text: 'Approved', value: '1' },
        { text: 'Declined', value: '2' },
      ],

      /** Sohel Code Starts Here */
      columns: columns,
      sortKey: 'employee_name',
      sortOrders: sortOrders,
      /** Sohel Code Ends Here */

      leaves:[],

      showoverlay:false,
      showoverlay_list:false,
      movenext : false,

      errormsg:[],
      fdata: {  },
      //

      search:'',
      length: 10,
      temp_length: 10,
      length_options: [
        { value: 10, text: "10" },
        { value: 20, text: "20" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
        { value: 500, text: "500" },
        { value: 1500, text: "1500" },
      ],
      pagination: {currentPage: 1, pages:1},

      ce : true,
      employee_id : 0,

      approved_leaves_today : 0,
      pending_leaves_today : 0,
      pending_leaves_fiscal_year : 0,
      tmp_leave_type_id : 0,
      tmp_flg_status : 0,
      tmp_from : '',
      tmp_to : '',
      tmp_leave_day : 0,
      unassigned_employees: [],
      selected_unassigned_employees: {},
      start_date: null,
      end_date: null,
      lv : [],
      this_month_holidays : [],
      this_month : 1,
      this_year : 2020,
      weekly_holidays : [6],
      first_day_of_week : 7,
      total_working_day : 0,
      total_weekends : 0,
      total_holidays : 0,
      weekend_color_code : '#aaaaaa',
      holiday_color_code : '#aaaaaa',
    }
  },
  methods:{
    moment,
    getBasisText(flg) {
      if(flg == 1) {
        return 'Shifts';
      }
      return 'Days';
    },
    checkLimits(employee_id){
      axios.get(this.$api_url + '/leave-attendance/employee/leaves', {
        params: {
          employee_id:employee_id
        }
      }).then(response => {
        this.leave_available = response.data.available;
        this.$bvModal.show('employeeLeavesLimitCheck');
      });
    },

    validateState(ref)
    {
      if (
          this.veeFields[ref] &&
          (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    isPastDate(date) {
      if (!date) return false;

      const givenDate = new Date(date);
      const today = new Date();

      givenDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      return givenDate <= today;
    },

    monthDetails: function(x)
    {
      let year = x['year'];
      let month = x['month'];
      let st_date = new Date(year , month - 1 , 1);
      let en_date = new Date(year , month , 0);

      this.this_month = x['month'];
      this.this_year = x['year'];

      this.start_date = moment(String(st_date)).format('Do MMMM YYYY');
      this.end_date = moment(String(en_date)).format('Do MMMM YYYY');

      // fetch holidays dynamically from controller
      axios.get(this.$api_url+'/leave-attendance/holidays/details' , {
        params: {
          st_date: this.start_date,
          en_date: this.end_date,
        }
      }).then(function(response){

        this.weekly_holidays = response.data.report.week_holidays;
        this.first_day_of_week = parseInt(response.data.report.week_start_day) + 1;

        this.this_month_holidays = response.data.holidays;

        this.total_working_day = response.data.report.total_working_day;
        this.total_weekends = response.data.report.weekends;
        this.total_holidays = response.data.report.holidays;
        this.weekend_color_code = response.data.report.weekend_color_code;
        this.holiday_color_code = response.data.report.holiday_color_code;
      }.bind(this)).catch((error) => { this.serverError(error);});
    },
    importLeaves: function()
    {
      this.$bvModal.show('bv-modal-import-leave');
    },

    hideModal(){
      this.$bvModal.hide('bv-modal-edit-leave');
      this.$bvModal.hide('bv-modal-add-leave');
    },

    getLeavesNew: function()
    {
      //this.showoverlay_list = true;
      if(!this.checkNet()) return false;

      if(this.flg == 0)
        this.employee_id = 0;


      this.$bvModal.hide('bv-modal-leave-details');
      this.search_by_id.flg_status = 0;
      axios.get(this.$api_url+'/leave-attendance/employee/leaves/fiscalyear' , {
        params: {
          search_by_id: this.search_by_id
        }
      }).then(function(response){

        this.leaves = response.data.leaves;
        this.employee_id = response.data.employee_id;
        this.excess = response.data.excess;

        this.approved_leaves_today = response.data.approved_leaves_today;
        //this.pending_leaves_today = response.data.pending_leaves_today;
        this.pending_leaves_fiscal_year = response.data.pending_leaves_today;
        this.$emit('childToParent');

        setTimeout(function () { this.showoverlay_list = false;
        }.bind(this), 1000);



        this.$bvModal.hide('bv-modal-edit-leave');
        this.$bvModal.hide('bv-modal-add-leave');


      }.bind(this)).catch((error) => { this.serverError(error);});
    },

    getLeaves: function()
    {
      this.showoverlay_list = true;
      if(!this.checkNet()) return false;

      if(this.flg == 0)
        this.employee_id = 0;


      this.$bvModal.hide('bv-modal-leave-details');
      this.search_by_id.flg_status = 0;
      axios.get(this.$api_url+'/leave-attendance/employee/leaves/fiscalyear' , {
        params: {
          search_by_id: this.search_by_id
        }
      }).then(function(response){
        this.$bvModal.hide('bv-modal-add-leave');
        this.$bvModal.hide('bv-modal-edit-leave');
        this.showoverlay_list = false;
        this.leaves = response.data.leaves;
        this.excess = response.data.excess;
        this.employee_id = response.data.employee_id;

        this.approved_leaves_today = response.data.approved_leaves_today;
        //this.pending_leaves_today = response.data.pending_leaves_today;
        this.pending_leaves_fiscal_year = response.data.pending_leaves_today;

      }.bind(this)).catch((error) => { this.serverError(error);});
    },

    getApprovePendingLeavesToday: function()
    {
      if(!this.checkNet()) return false;

      axios.get(this.$api_url+'/leave-attendance/approve-pending/leaves/today' , {
        params: {
          //employee_id: this.employeeId
        }
      }).then(function(response){
        this.approved_leaves_today = response.data.approved_leaves_today;
        this.pending_leaves_today = response.data.pending_leaves_today;
        this.pending_leaves_fiscal_year = response.data.pending_leaves_fiscal_year;


      }.bind(this)).catch((error) => { this.serverError(error);});
    },
    setEmployee: function(x)
    {
      this.employee_id = x.employee_id;
    },
    addNew()
    {
      if(this.flg == 0)
        this.employee_id = 0;

      this.$bvModal.show('bv-modal-add-leave');
    },

    //editLeave(leave.employee_id,leave.leave_type_id,leave.flg_status,leave.from,leave.to)
    editLeave: function(employee_id , leave_type_id , flg_status , from , to , leave_day)
    {
      if(!this.checkNet()) return false;
      this.employee_id = 0;
      let formData = new FormData();
      formData.append('employee_id' , employee_id);
      axios.post(this.$api_url+'/employee/setemployee', formData)
          .then((response) =>
          {
            this.employee_id = employee_id;

            this.tmp_leave_type_id = leave_type_id;
            this.tmp_flg_status = flg_status;
            this.tmp_from = from;
            this.tmp_to = to;
            this.tmp_leave_day = leave_day;

            this.$bvModal.show('bv-modal-edit-leave');

          })
          .catch((error) =>
          {
            this.showoverlay = false;
            this.serverError(error);
          });

    },
    showReplacementModal(leave){
      this.$bvModal.hide('bv-modal-add-leave');
      if(leave.is_roster == 0){
        this.updateLeave(leave.employee_id,leave.leave_type_id,leave.flg_status,leave.from,leave.to , 1);
        return;
      }

      let assignment_ids = Object.values(leave.shifts).flat().map(shift => shift.id);

      let assignment_map = Object.fromEntries(
          Object.entries(leave.shifts).map(([date, shifts]) => [
            date,
            shifts.map(shift => shift.id)
          ])
      );

      let formData = new FormData();
      formData.append('assignments', JSON.stringify(assignment_map));

      axios.post(this.$api_url + '/leave-attendance/employees/range/group', formData).then((res) => {
            if (res.data) {
              this.unassigned_employees = res.data;

              this.selected_unassigned_employees = this.selected_unassigned_employees || {};
              Object.entries(assignment_map).forEach(([date, shiftIds]) => {
                if (!this.selected_unassigned_employees[date]) {
                  this.$set(this.selected_unassigned_employees, date, {});
                }
                shiftIds.forEach((sid) => {
                  this.$set(this.selected_unassigned_employees[date], String(sid), null);
                });
              });

              let day_type = 'shift';
              let days = assignment_ids.length;
              if(days > 1) day_type += 's';

              this.employeeLeaveDetails = {
                leave: leave,
                employee: leave.employee_name,
                department: leave.department,
                jobposition: leave.jobposition,
                leaveType: leave.leave_type,
                duration: days + ' ' + day_type,
                period: leave.from + " to " + leave.to,
                reason: leave.reason,
                shifts: leave.shifts,
              };

              this.$bvModal.show('approve-leave-modal');
            } else {
              this.unassigned_employees = {};
            }
            this.showoverlay = false;
          }).catch((err) => {
            this.showoverlay = false;
            this.serverError(err);
          });
    },
    updateLeave: function(employee_id , leave_type_id , flg_status , from , to , status)
    {
      if(!this.checkNet()) return false;
      this.employee_id = 0;
      this.showoverlay_list = true;
      let formData = new FormData();
      formData.append('employee_id' , employee_id);
      formData.append('leave_type_id' , leave_type_id);
      formData.append('flg_status' , flg_status);
      formData.append('from' , from);
      formData.append('to' , to);
      formData.append('status' , status);

      axios.post(this.$api_url+'/leave-attendance/employee/leaves/status', formData).then( (response) =>
          {
            this.getLeavesNew();

          }).catch((error)=>{
            this.showoverlay = false;
            this.showoverlay_list = false;
            this.serverError(error);
          });

    },
    deleteLeave: function(employee_id , leave_type_id , flg_status , from , to)
    {
      let formData = new FormData();
      formData.append('employee_id' , employee_id);
      formData.append('leave_type_id' , leave_type_id);
      formData.append('from' , from);
      formData.append('to' , to);
      formData.append('flg_status' , flg_status);



      axios.post(this.$api_url+'/leave-attendance/leave/delete/range', formData)
          .then(function (response)
          {
            this.$bvToast.toast('Deleted!', {
              title: `Success`,
              variant: 'success',
              solid: true
            });


            this.getLeaves();
            //this.getApprovePendingLeavesToday();

          }.bind(this))
          .catch( (error) =>
          {
            this.showoverlay = false;
            this.serverError(error);
          });
    },

    setSelected(date, shiftId, val) {
      const sid = String(shiftId);
      if (!this.selected_unassigned_employees[date]) {
        this.$set(this.selected_unassigned_employees, date, {});
      }
      this.$set(this.selected_unassigned_employees[date], sid, val);
    },
    replaceShifts() {
      this.updateLeave(
          this.employeeLeaveDetails.leave.employee_id,
          this.employeeLeaveDetails.leave.leave_type_id,
          this.employeeLeaveDetails.leave.flg_status,
          this.employeeLeaveDetails.leave.from,
          this.employeeLeaveDetails.leave.to,
          1
      );

      const payload = Object.entries(this.selected_unassigned_employees || {}).flatMap(([date, shiftsObj]) =>
              Object.entries(shiftsObj || {})
                  .filter(([, employeeId]) => employeeId != null && employeeId !== '')
                  .map(([shiftId, employeeId]) => ({
                    date,
                    shift_id: Number(shiftId),
                    employee_id: Number(employeeId),
                  }))
          );

      const formData = new FormData();
      formData.append('payload', JSON.stringify(payload));

      axios.post(this.$api_url + '/leave-attendance/shift/reassign', formData)
          .then(() => {
            this.$bvModal.hide('approve-leave-modal');
            this.$bvToast.toast("Shifts Reassigned Successfully", {
              variant: 'success',
              title: 'Success',
              solid: true,
            });
            this.getLeavesNew();
          })
          .catch(e => {
            this.serverError(e);
          });
    },

    getDepartments: function(){
      axios.get(this.$api_url+'/department/list').then((response) => {
        this.depertments = response.data;
      });

    },

    dateDisabled(ymd, date) {
      const x = moment(String(date)).format('YYYY-MM-DD');
      return this.all_week_holidays.includes(x) || this.holidays_date_arr.includes(x);
    },
    updateToDate:function()
    {
      if(this.fake == 1)return;
      this.day_two = this.day_one;
      this.min = this.day_one;
    },
    checkValidDate:function()
    {
      if(moment(this.day_two).isBefore(moment(this.day_one).format('YYYY-MM-DD')))
        this.updateToDate();
    },

    getDisabledDates:function()
    {
      axios.get(this.$api_url+'/leave-attendance/holidays/details' , {
        params: {
          //id: x
        }
      }).then(function(response){

        if(response.data.length != 0)                    {
          this.all_week_holidays = response.data.report.week_holidays;
          this.week_start_day =  response.data.report.week_start_day;
          this.holidays_date_arr = response.data.report.holidays_date_arr.split(',').map(function(item){ return item;});
        }
      }.bind(this));
    },
    getLeaveTypes: function()
    {
      if(!this.checkNet()) return false;
      axios.get(this.$api_url+'/leave-attendance/leave/types' , {

      }).then(function(response){

        this.leavetypes = response.data;
      }.bind(this));
    },

    resetFlter : function()
    {
      this.day_one = '';
      this.day_two = '';

      this.search_by_id.day_one = '';
      this.search_by_id.day_two = '';
      this.search_by_id.department_id = 0;
      this.search_by_id.leave_type_id = 0;
      this.search_by_id.flg_status = 0;
      this.getLeaves();
      this.$root.$emit('bv::toggle::collapse', 'sidebar_right_1');
    },
    setFlter : function()
    {
      this.search_by_id.day_one = this.day_one;
      this.search_by_id.day_two = this.day_two;
      this.getLeaves();
      this.$root.$emit('bv::toggle::collapse', 'sidebar_right_1');
    },
    getCompanyLeaveSettings:function()
    {
      if(!this.checkNet()) return false;
      axios.get(this.$api_url+'/front/leave-attendance/company/leave/settings').then(function(response){

        if(response.data.length != 0)
        {
          this.carry = response.data.carry;
          this.encash = response.data.encash;
        }
      }.bind(this));
    },
    setFirstPage() {
      this.pagination.currentPage = 1;
      this.length = this.temp_length;
    }
  },
  created: function(){

    this.columns = this.columns.map(column => ({ ...column }));

    this.columns = this.columns.map(column => {
      if (column.name == 'number_of_days') {
        return {
          ...column,
          label: 'No. of Days' + (this.roster == 1 ? '/Shifts' : '')
        };
      }

      return column;
    });

    if (this.roster != 1) {
      this.columns = this.columns.filter(column => column.name != 'shifts');
    }

    this.getDepartments();
    this.getLeaveTypes();
    this.resetFlter();
    this.getCompanyLeaveSettings();
    //this.getEmployeeLeaveSettings();
    this.getDisabledDates();
    //this.getApprovePendingLeavesToday();
    //Fire.$on('reloadUsers', () => {this.getLeaves()});
  },
  computed:
      {
        filteredData()
        {
          let filtered_list = this.leaves;
          if (this.search)
          {

            filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

            if(filtered_list.length == 0)
              this.blankmsg = "Nothing found.";
          }

          let sortKey = this.sortKey;
          let order = this.sortOrders[sortKey] || 1;
          if (sortKey)
          {
            filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                  a = String(a[sortKey]).toLowerCase();
                  b = String(b[sortKey]).toLowerCase();
                  if (this.columns[index].type && this.columns[index].type == 'date')
                  {
                    return (a == b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                  }
                  else if (this.columns[index].type && this.columns[index].type == 'number')
                  {
                    return (+a == +b ? 0 : +a > +b ? 1 : -1) * order;
                  }
                  else
                  {
                    return (a == b ? 0 : a > b ? 1 : -1) * order;
                  }
                }
            );
          }

          return filtered_list;
        },
        paginatedData()
        {
          return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        },

        fetchStartWeekday()
        {
          return this.week_start_day;
        },
      }
}
</script>

